import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'app/core/material_modules/material.module';
import { FilePlaceholderComponent } from './file-placeholder.component';
import { lucideMoreVertical } from '@ng-icons/lucide';
import { HlmIconComponent, provideIcons } from '@spartan-ng/ui-icon-helm';
import { BrnMenuTriggerDirective } from '@spartan-ng/ui-menu-brain';
import { HlmMenuModule } from '@spartan-ng/ui-menu-helm';

@NgModule({
  declarations: [
    FilePlaceholderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MaterialModule,
    HlmIconComponent,
    BrnMenuTriggerDirective,
    HlmMenuModule
  ],
  exports: [
    FilePlaceholderComponent
  ],
  providers: [provideIcons({  lucideMoreVertical})]
})
export class FilePlaceholderModule { }
